/**
 * Environment State — Types & Initial Values
 *
 * Defines the shape of the env slice and its starting state.
 * The env slice holds environment configuration that affects
 * how the app connects to APIs and renders (region, stage, theme).
 */
import { getRegionFromUrl, getStageFromUrl, getApiBase } from '../../../constants';

/** Light or dark mode */
export type Theme = 'light' | 'dark';

/** Shape of the env slice state */
export interface EnvState {
  /** Currently selected AWS region (e.g. 'us-east-1') */
  region: string;
  /** Deployment stage derived from URL (Alpha, Beta, Gamma, Prod) */
  stage: string;
  /** Resolved API base URL for the current region + stage */
  apiBase: string;
  /** UI theme preference */
  theme: Theme;
}

const stage = getStageFromUrl();
const region = getRegionFromUrl();

/** Initial state — region & stage are restored from the URL so they survive a refresh */
export const envInitialState: EnvState = {
  region,
  stage,
  apiBase: getApiBase(stage, region),
  theme: 'light',
};
